import tmhRequest from "@/config/tmhRequest";

export default {
  searchTargetQuestion: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchtargetquestion",
      method: "get",
      params: data,
    });
  },

  searchHealthReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchhealthreport",
      method: "get",
      params: data,
    });
  },

  createHealthReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/createhealthreport",
      method: "post",
      data: data,
    });
  },

  searchHealthScreenReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchhealthscreenreport",
      method: "get",
      params: data,
    });
  },

   searchLatelyHealthReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchlatelyhealthreport",
      method: "get",
      params: data,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/tmh/health/healthreport.js